var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-simple",class:[
    _vm.small ? 'label-simple--small' : '',
    _vm.dot ? 'label-simple--dot' : '',
    _vm.item.classColor,
    _vm.hasCustomDot ? 'label-simple--custom-dot' : '',
  ],style:({ color: _vm.item.color })},[(_vm.hasCustomDot)?_c('div',{staticClass:"custom-dot"},[_vm._t("default")],2):_vm._e(),_vm._v(" "+_vm._s(_vm.dot ? "" : _vm.item.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }